<template>
<div>
    <div>
        <base-title no-margin-top class=""> Supervisors on Shift </base-title>
    </div>
    <div>
        <span
            v-for="(supervisor, key) in supervisors"
            :key="key"
            class="font-weight-medium grey--text text--darken-2 mr-4 text-subtitle-2"
        >
            <v-icon
                color="primary"
                class="mr-1 my-1"
            >
                mdi-account-circle
            </v-icon>
            {{ supervisor.name }}
        </span>
    </div>
</div>
</template>

<script>
    export default {
        data: () => ({
            supervisors: []
        }),
        methods: {
            getSupervisors() {
                this.supervisors = [
                    { name: "Robert Downy Jr." },
                    { name: "Andres Bonifacio" },
                    { name: "Elizabeth Bayon" }
                ];
            }
        },
        mounted() {
            this.getSupervisors();
        }
    }
</script>
